(function(window, angular, undefined) {
angular.module('formApp')
    .controller('retrieveEquoteCtrl', ['$scope', 'FormService', 'updateHeader', 'formData', '$state', 'stateService', 'errorHandler', 'LoadingInterceptor', 'sessionService', '$location','$rootScope', '$q',
        function($scope, formService, updateHeader, formData, $state, stateService, errorHandler, loadingInterceptor, sessionService, $location, $rootScope, $q) {
            
        sessionService.stop();
        $scope.dobDateMin = moment().format('YYYY-MM-DD');
        $scope.dobDateMax = moment().subtract(99, 'year').format('YYYY-MM-DD');
        $scope.retrieveQuote = {};
        $scope.straightThroughValidation = false;

        var refNo = $location.search().RefNo;
        if (refNo) {
            $scope.retrieveQuote.quoteRef = parseInt(refNo, 10);
        }

        var pastCoverStartDate = false;

        $scope.formData = formData;
        $scope.equote = true;

        if (!sessionStorage.getItem('formStateUri')) {
            var petValue = $location.search().petvalue;
            if (['dog', 'cat', 'rabbit'].indexOf(petValue) !== -1) {
                $scope.formData.pets[0].type = petValue;
                sessionStorage.setItem('petType', petValue);
                updateHeader.petType = petValue;
            }
            
            $scope.breed = $location.search().breed;
            if (['beagle','border-collie','cockapoo','cocker-spaniel','dachshund','german-shepherd','golden-retriever','labradoodle','labrador','pomeranian','pug', 'shih-tzu'].indexOf($scope.breed) !== -1) {
                sessionStorage.setItem('petBreed', $scope.breed);
                updateHeader.petType = $scope.breed;
            }
        } else {
            updateHeader.petType = 'default';
        }

            //straight through validation logic
             var params = {}, encryptedParams = getUrlParameter('encryptedParams'), parisRef = getUrlParameter('RefNo');
             $scope.straightThroughValidation = encryptedParams !== '' ? true : false;

            angular.element(document).ready(function () {
                if (encryptedParams !== '') {
                    params = {
                        encryptedParams: encryptedParams,
                        parisRef:parisRef
                        };
                    loadingInterceptor.incrementRequests();
                    setTimeout(function () {
                        getQuoteDetails(params);
                        loadingInterceptor.decrementRequests();
                    }, 2000);
                }
            });

        function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1]).replace(/ /g, '+');
        }

        $scope.submit = function() {
    
            var params = {
                quoteRef: $scope.retrieveQuote.quoteRef,
                postCode: $scope.retrieveQuote.postCode,
                dob: $scope.retrieveQuote.dob
            };

            getQuoteDetails(params);
        };

            //STV logic split
        function getQuoteDetails(params){
            var application;

            loadingInterceptor.incrementRequests();
            formService.getQuote(params).then(
                function(response) {
            
                    formService.setApplicationId(response.data.uri.split('/').pop());
                    formService.setQuoteExpiry(response.data.isQuoteExpired);
                    return formService.getApplication();
                }
            ).then(
                function(response) {
                    
                    application = response.data;

                    // reset any existing campaign info
                    $scope.$parent.campaign = '';
                    $scope.$parent.brav = '';
                    sessionStorage.removeItem('campaign');
                    sessionStorage.removeItem('brav');

                    if (application.officeUseOnly && application.officeUseOnly.params) {
                        $scope.$parent.campaign = application.officeUseOnly.params.campaign;
                        sessionStorage.setItem('campaign',$scope.$parent.campaign);

                        $scope.$parent.brav = application.officeUseOnly.params.brav;
                        sessionStorage.setItem('brav',$scope.$parent.brav);
                    }

                    if (moment(application.application.cover.startDate).isBefore( moment().format('YYYY-MM-DD') )) {
                        pastCoverStartDate = true;
                        var coverStartDate = {
                            startDate: moment().format('YYYY-MM-DD')
                        };
                        return formService.postCover(coverStartDate);
                    } else {
                        var deferred = $q.defer();
                        deferred.resolve();
                        return deferred.promise;
                    }
                }
            ).then(
                function() {
                
                    if (pastCoverStartDate) {
                        return formService.getRunningTotals();
                    } else {
                        var deferred = $q.defer();
                        deferred.resolve();
                        return deferred.promise;
                    }
                } 
            ).then(
                function() {
                
                    return formService.getSchema(application.schema.split('/').pop());
                } 
            ).then(
                function(response) {
                    
                    $scope.$parent.schema = response.data;
                    return formService.getApplication();
                }
            ).then(
                function(response) {
                    application = response.data;
                    populateFormData(application);
                    
                    loadingInterceptor.decrementRequests();

                    var appState = getApplicationState(application.application);
                    sessionService.start();
                    if(sessionStorage.getItem('isQuoteExpired') === 'Y') {
                        sessionStorage.setItem('currentRefreshState', 'retrieve-expired');
                            // Quick fix remove before live//
                        var env = window.location.hostname;
                        if (env.search('petplan.co.uk') !== -1 || env.search('azuk.cloud') !== -1) {
                            window.location.href='/retrieve-expired';
                        }
                        else {
                            window.location.href='/content/ah_small-animal/index.html/retrieve-expired';
                        }
                        // Quick fix remove before live//
                    }
                    else{
                        $state.go(appState.step, {forward: true, petId: appState.petId, position: appState.position, retrieve: appState.retrieve});
                    }
                }
            ).catch(
                function(error) {
                    if (encryptedParams) {
                        //if decryption fails redirect to normal retrieval rather than going to error screen
                        encryptedParams = '';
                        $scope.straightThroughValidation = false;
                        errorHandler.reportErrors(error, 'decryptionFailed', 'alt-retrieve-ec');
                    }
                    else {
                        console.log("retrieve quote error");
                        errorHandler.reportErrors(error, 'redirect', 'retrieve');
                    }
                }
            );
        }

        function populateFormData(data) {
            sessionStorage.setItem('eQuote', 'true');
            $rootScope.eQuote = true;
            
            $scope.formData.pets = data.application.pets;
            $scope.formData.aboutYou = data.application.aboutYou;
            $scope.formData.cover = data.application.cover;
            $scope.formData.charitableDonation = data.application.charitableDonation;
        }

        function getApplicationState(application) {

            var step = 'step-4',
                petId,
                position,
                index;

            if (step === 'step-4') {
                position = null;
                index = 0;
                petId = index;
                while(index <= application.pets.length - 1 && application.pets[index].chosenCover) {
                    if (application.pets[index].chosenCover) {
                        if (application.pets[index].chosenCover.productId) {
                            position = 'summary';
                        } else {
                            position = 'quote';
                        }
                        petId = index;
                    }

                    index = index + 1;
                }
            }

            
            return {
                step: step,
                petId: petId,
                position: position,
                retrieve: true
            };
        }
    }]);
})(window, window.angular);